import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import axios from "axios";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Passwords don't match"); return; }
    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/auth/reset-password`, { token, new_password: password });
      toast.success("Password updated - sign in with your new password");
      navigate("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not reset password");
    } finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-6">
      <div className="w-full max-w-sm rounded-2xl border border-slate-200 bg-white p-8">
        <Logo />
        <h1 className="h-display mt-8 text-2xl font-semibold text-foreground">Choose a new password</h1>
        {!token ? (
          <p className="mt-4 text-sm text-red-600" data-testid="reset-no-token">This link is missing its token. Request a new reset link from the sign-in page.</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <Label htmlFor="pw">New password</Label>
              <Input id="pw" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} placeholder="At least 8 characters" className="mt-1" data-testid="reset-password" />
            </div>
            <div>
              <Label htmlFor="pw2">Confirm password</Label>
              <Input id="pw2" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} placeholder="••••••••" className="mt-1" data-testid="reset-confirm" />
            </div>
            <Button type="submit" className="w-full" disabled={loading} data-testid="reset-submit">
              {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Update password
            </Button>
          </form>
        )}
        <p className="mt-6 text-center text-sm text-muted-foreground">
          <Link to="/login" className="font-medium text-primary hover:underline" data-testid="reset-back-login">Back to sign in</Link>
        </p>
      </div>
    </div>
  );
}
